import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";
import axios from '../../../../services/AxiosInstance';
import swal from "sweetalert";
import { Link } from "react-router-dom";
import DepartmentList from "./RateList";
//import { useSelector,useDispatch } from 'react-redux';
//import { fetchDepartmentData } from  '../../../../store/actions/DepartmentAction';

const RateMaster = () => {
    const [departname,setDepartmentMaster] = useState([]);
    //const userdetails = JSON.parse(localStorage.getItem('userDetails'));
    //const dispatch = useDispatch();
    //const {departments} = useSelector(state => state.departments);
    function getRateMasterData(){
      axios.get(`/api/auth/rate-details`)
      .then((res) => {
         console.log("Department List");
         console.log(res.data.rates);
         setDepartmentMaster(res.data.rates);
      })
      .catch((error) => {
         swal("Please try again",error.message, "error");
      })
    }
    useEffect(()=>{
      getRateMasterData();
      //dispatch(fetchDepartmentData());
    },['']);
    const DataTable = () => {
      return departname.map((res, i) => {
        return <DepartmentList obj={res} key={i} />;
      });
    };
   
    return (
      <Fragment>
         <PageTitle activeMenu="Department Master" motherMenu="Users" />
         <div className="row">
            <div className="col-lg-12">
               <div className="card">
                  <div className="card-body">
                    <Link className="btn btn-primary font-w600 mb-2 me-auto" to={"/add-rate"}>+ Add Rates</Link>
                     <div className="table-responsive" style={{minHeight:"200px"}}>
                        <table className="primary-table-bordered table">
                           <thead class="thead-primary">
                              <tr>
                                 <th>Product Name</th>
                                 <th>Bid</th>
                                 <th>Bid - H</th>
                                 <th>Ask</th>
                                 <th>Ask - L</th>
                                 <th>State</th>
                                 <th></th>
                              </tr>
                           </thead>
                           <tbody>
                           {DataTable()}
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   );
}
export default RateMaster;